module.exports = __webpack_public_path__ + "img/bory_druzstevne-byvanie_ikony_prebratie_bytu.8672e3de.svg";